import toast from 'react-hot-toast'
import { Button } from 'components/common'
import { DownloadIcon } from 'components/icons'
import { downloadFtpLogs } from 'utils/api/logsApi'

const FtpLogExportButton = () => {
  const downloadCsv = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      await downloadFtpLogs()
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <div className="mb-5">
      <Button
        buttonText="Export"
        className="flex w-40 justify-start px-0"
        icon={<DownloadIcon />}
        onClick={downloadCsv}
      />
    </div>
  )
}

export default FtpLogExportButton
